import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import CountriesListActions from '../ducks/countries-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/country`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(CountriesListActions.success(data, pagination));
  } catch (err) {
    yield put(CountriesListActions.failure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/country?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    yield put(CountriesListActions.showSuccess(list));
  } catch (err) {
    yield put(
      CountriesListActions.showFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
